import { render } from "./x1_topo.vue?vue&type=template&id=bf8b6f4c&scoped=true"
import script from "./x1_topo.vue?vue&type=script&lang=js"
export * from "./x1_topo.vue?vue&type=script&lang=js"

import "./x1_topo.vue?vue&type=style&index=0&id=bf8b6f4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf8b6f4c"]])

export default __exports__